"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZBanner = exports.BannerContext = exports.ZMenuItem = void 0;
const React = __importStar(require("react"));
const _ = __importStar(require("lodash"));
const AppContext_1 = require("../../utils/AppContext");
const core_1 = require("@material-ui/core");
const react_router_dom_1 = require("react-router-dom");
const ll_1 = require("../../languages/ll");
const react_1 = require("react");
const useViewport_1 = require("../../utils/useViewport");
const styles_1 = require("@material-ui/core/styles");
const AccountCircle_1 = __importDefault(require("@material-ui/icons/AccountCircle"));
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const Menu_2 = __importDefault(require("@material-ui/icons/Menu"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const classnames_1 = __importDefault(require("classnames"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.ZMenuItem = props => (React.createElement(MenuItem_1.default, Object.assign({}, props)));
exports.BannerContext = React.createContext({});
exports.BannerContext.displayName = "BannerContext";
const drawerWidth = 300;
const Logo = styled_components_1.default.img.attrs(props => {
    return { src: props.theme["app-logo-color-url"] };
}) `
   max-height: 43px;
   vertical-align: middle;
   margin-right: 15px;
   &:hover {
      filter: drop-shadow(4px 4px 12px ${props => props.theme["active-color"]});
   }
`;
const ZBannerComponent = (props) => {
    const [drawerOpen, setDrawerOpen] = react_1.useState(false);
    const [anchorEl, setAnchorEl] = react_1.useState(null);
    const [menuOpen, setMenuOpen] = react_1.useState(false);
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };
    const handleCloseMenu = (event) => {
        setAnchorEl(null);
        setMenuOpen(false);
    };
    const offscreenToolbarDivRef = react_1.useRef(null);
    const [wideEnough, setWideEnough] = react_1.useState(false);
    const { innerWidth } = useViewport_1.useViewport();
    react_1.useEffect(_.debounce(() => {
        if (offscreenToolbarDivRef.current) {
            setWideEnough(offscreenToolbarDivRef.current.scrollWidth <=
                offscreenToolbarDivRef.current.clientWidth);
        }
    }, 250), [setWideEnough, innerWidth]);
    react_1.useEffect(() => {
        const clickHandler = (e) => {
            if (e.target.closest("#drawer") === null &&
                e.target.closest("#hamburger-menu") === null)
                setDrawerOpen(false);
        };
        if (drawerOpen == true) {
            window.addEventListener("mouseup", clickHandler, true);
        }
        return () => {
            window.removeEventListener("mouseup", clickHandler, true);
        };
    }, [drawerOpen]);
    const children = props.children;
    const { classes } = props;
    const { languageId } = React.useContext(ll_1.llContext);
    const currentRoute = react_router_dom_1.useLocation();
    return (React.createElement(exports.BannerContext.Provider, { value: {
            drawerOpen,
            setDrawerOpen,
            wideEnough,
            children
        } },
        React.createElement("div", { id: "banner", className: props.className },
            React.createElement(AppBar_1.default, { position: "fixed", color: "default", className: classes.appBar },
                React.createElement(Toolbar_1.default, { variant: "dense", className: classes.toolbar },
                    React.createElement("div", { id: "toolbar" },
                        !drawerOpen ? (React.createElement("div", { id: "hamburger-menu", className: wideEnough && !currentRoute ? "disabled" : "" },
                            React.createElement(core_1.IconButton, { color: "inherit", "aria-label": "Menu", onClick: () => {
                                    setDrawerOpen(!drawerOpen);
                                }, disabled: wideEnough && !currentRoute },
                                React.createElement(Menu_2.default, { "aria-label": "Open drawer" })))) : null,
                        React.createElement("div", { id: "banner-items" },
                            React.createElement(Typography_1.default, { variant: "h6", color: "inherit" },
                                React.createElement(Button_1.default, null,
                                    React.createElement("span", { title: "Home", onClick: _e => {
                                            props.homeClickHandler &&
                                                props.homeClickHandler();
                                        } },
                                        React.createElement(react_router_dom_1.Link, { to: "/" },
                                            React.createElement(Logo, null)))),
                                React.Children.map(props.children, child => {
                                    return React.cloneElement(child, {
                                        key: child.props.text,
                                        current: currentRoute &&
                                            currentRoute.pathname.startsWith(child.props.link)
                                    });
                                }))),
                        React.createElement("div", { id: "account-button" },
                            React.createElement(core_1.IconButton, { "aria-owns": menuOpen ? "menu-appbar" : undefined, "aria-haspopup": "true", onClick: handleOpenMenu, color: "inherit" },
                                React.createElement(AccountCircle_1.default, null),
                                React.createElement("span", { id: "username" }, props.user && props.user.name)),
                            React.createElement(Menu_1.default, { id: "menu-appbar", anchorEl: anchorEl, anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "right"
                                }, transformOrigin: {
                                    vertical: "top",
                                    horizontal: "right"
                                }, open: menuOpen, onClose: handleCloseMenu }, props.menuItems
                                ? React.Children.map(props.menuItems, child => (React.createElement("div", null, React.cloneElement(child, {
                                    onClick: (event) => {
                                        child.props.onClick &&
                                            child.props.onClick(event);
                                        handleCloseMenu(event);
                                    }
                                }))))
                                : [
                                    React.createElement(MenuItem_1.default, { onClick: handleCloseMenu }, ll_1.ll({ key: "Settings", languageId })),
                                    React.createElement(MenuItem_1.default, { onClick: handleCloseMenu }, ll_1.ll({ key: "LogOut", languageId }))
                                ]))))),
            React.createElement(AppBar_1.default, { position: "fixed", style: { top: -100 }, className: classes.appBar },
                React.createElement(Toolbar_1.default, { variant: "dense", className: classes.toolbar },
                    React.createElement("div", { id: "offscreen-toolbar", ref: offscreenToolbarDivRef },
                        React.createElement("div", { id: "offscreen-banner-items" },
                            React.createElement(Typography_1.default, { variant: "h6", color: "inherit" },
                                React.createElement(Button_1.default, null,
                                    React.createElement("span", { title: "Home" },
                                        React.createElement(react_router_dom_1.Link, { to: "/" },
                                            React.createElement(Logo, null)))),
                                React.Children.map(props.children, child => {
                                    return React.cloneElement(child, {
                                        key: child.props.text,
                                        current: currentRoute &&
                                            currentRoute.pathname.startsWith(child.props.link),
                                        forceRender: true
                                    });
                                }))),
                        React.createElement("div", { id: "offscreen-account-button" },
                            React.createElement(core_1.IconButton, { "aria-owns": menuOpen ? "menu-appbar" : undefined, "aria-haspopup": "true", color: "inherit" },
                                React.createElement(AccountCircle_1.default, null),
                                React.createElement("span", { id: "offscreen-username" }, props.user && props.user.name))))))),
        React.createElement(StyledDrawer, { visible: drawerOpen })));
};
const PoweredBy = styled_components_1.default.div `
   display: flex;
   justify-content: center;
   background: ${props => props.theme["banner-background-color"]};
   color: ${props => props.theme["banner-tab-link-color"]};
   & div {
      font-size: 10px !important;
      padding: 8px;
      align-self: flex-end;
   }
`;
const CustomDrawer = (props) => {
    const { children, setDrawerOpen } = React.useContext(exports.BannerContext);
    const { brand } = React.useContext(AppContext_1.AppContext);
    const { classes } = props;
    return (React.createElement("div", null,
        React.createElement(core_1.Drawer, { variant: "persistent", anchor: "left", open: props.visible, transitionDuration: 250, className: classnames_1.default(classes.drawer, {
                [classes.drawerOpen]: props.visible,
                [classes.drawerClose]: !props.visible
            }), classes: {
                paper: classnames_1.default({
                    [classes.drawerOpen]: props.visible,
                    [classes.drawerClose]: !props.visible
                })
            }, SlideProps: { direction: "right" } },
            React.createElement("div", { style: { height: 50 } }),
            React.createElement("div", { className: props.className, id: "drawer" },
                React.createElement(core_1.IconButton, { onClick: () => {
                        setDrawerOpen(false);
                    }, className: "close-button" },
                    React.createElement(ChevronLeft_1.default, null)),
                React.createElement(core_1.List, null,
                    React.createElement(DrawerItems, { items: children }))),
            brand && brand.customLogoURL ? (React.createElement(PoweredBy, null,
                React.createElement("div", null, ll_1.ll({
                    key: "PoweredBy",
                    variables: [brand.name]
                }) + "™"))) : null)));
};
const DrawerItems = (props) => {
    const { setDrawerOpen, wideEnough } = React.useContext(exports.BannerContext);
    const { languageId } = React.useContext(ll_1.llContext);
    const children = props.items;
    const currentRoute = react_router_dom_1.useLocation();
    return (React.createElement("div", null, React.Children.map(children, (child, index) => {
        const { text, link } = child.props;
        const DrawerListItem = (props) => {
            const key = text;
            return (React.createElement(core_1.ListItem, { classes: {
                    selected: "drawer-selected"
                }, selected: currentRoute.pathname.startsWith(link), button: true, key: key, onClick: () => {
                    setDrawerOpen(false);
                } },
                React.createElement(core_1.ListItemText, { key: key, primary: ll_1.ll({ key: text, languageId }) })));
        };
        const DrawerListSubItem = (props) => {
            const { grandchild } = props;
            const key = grandchild.props.text;
            return (React.createElement(core_1.ListItem, { selected: currentRoute.pathname.startsWith(grandchild.props.link), classes: {
                    selected: "drawer-subitem-selected"
                }, button: true, key: key, onClick: () => {
                    setDrawerOpen(false);
                } },
                React.createElement(core_1.ListItemText, { className: "drawer-subitem", primary: ll_1.ll({
                        key: grandchild.props.text,
                        languageId
                    }) })));
        };
        return (React.createElement(React.Fragment, null,
            !wideEnough || currentRoute.pathname.startsWith(link) ? (React.createElement(react_router_dom_1.Link, { to: link }, React.createElement(DrawerListItem, null))) : null,
            currentRoute.pathname.startsWith(link) &&
                child.props.children ? (React.createElement(core_1.List, null, React.Children.map(child.props.children, grandchild => (React.createElement(react_router_dom_1.Link, { to: grandchild.props.link },
                React.createElement(DrawerListSubItem, { grandchild: grandchild })))))) : null));
    })));
};
const materialStyles = (materialTheme) => {
    return {
        root: {
            display: "flex"
        },
        appBar: {
            zIndex: materialTheme.zIndex.drawer + 1,
            transition: materialTheme.transitions.create(["width", "margin"], {
                easing: materialTheme.transitions.easing.sharp,
                duration: materialTheme.transitions.duration.leavingScreen
            })
        },
        drawerOpen: {
            width: drawerWidth,
            transition: materialTheme.transitions.create("width", {
                easing: materialTheme.transitions.easing.sharp,
                duration: materialTheme.transitions.duration.enteringScreen
            })
        },
        drawerClose: {
            transition: materialTheme.transitions.create("width", {
                easing: materialTheme.transitions.easing.sharp,
                duration: materialTheme.transitions.duration.leavingScreen
            }),
            width: materialTheme.spacing(7) + 1
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0
        },
        drawerPaper: {
            width: drawerWidth
        },
        content: {
            flexGrow: 1,
            padding: materialTheme.spacing(3),
            transition: materialTheme.transitions.create("margin", {
                easing: materialTheme.transitions.easing.sharp,
                duration: materialTheme.transitions.duration.leavingScreen
            })
        },
        contentShift: {
            transition: materialTheme.transitions.create("margin", {
                easing: materialTheme.transitions.easing.easeOut,
                duration: materialTheme.transitions.duration.enteringScreen
            }),
            marginLeft: 0
        }
    };
};
const StyledDrawer = styles_1.withStyles(materialStyles)(styled_components_1.default(CustomDrawer) `
   width: ${drawerWidth}px;
   height: 100%;
   overflow-y: auto;
   background: ${props => props.theme["banner-background-color"]};
   color: ${props => props.theme["banner-tab-link-color"]};
   & a {
      text-decoration: none;
      color: unset;
   }
   & span {
      font-family: ${props => props.theme["font-family"]};
      font-size: 18px;
      color: ${props => props.theme["banner-tab-link-color"]};
   }
   & div:hover > span {
      color: ${props => props.theme["hover-color"]};
      cursor: pointer;
   }
   & div:active > span {
      color: ${props => props.theme["active-color"]};
   }
   .close-button + ul.MuiList-root {
      margin-top: -10px;
      padding-top: 0px;
   }
   && .drawer-selected {
      background: ${props => props.theme["drawer-selected-background-color"]};
      & span {
         font-weight: bold;
         font-size: 18px;
         color: ${props => props.theme["banner-tab-link-color"]};
      }
      &:hover {
         & span {
            color: ${props => props.theme["hover-color"]};
         }
         cursor: pointer;
         background: ${props => props.theme["drawer-selected-background-color"]};
      }
      &:active span {
         color: ${props => props.theme["active-color"]};
      }
   }
   && .drawer-subitem-selected {
      background: ${props => props.theme["drawer-selected-background-color"]};
      & span {
         font-weight: bold;
         color: ${props => props.theme["banner-tab-link-color"]};
      }
      &:hover {
         & span {
            color: ${props => props.theme["hover-color"]};
         }
         background: ${props => props.theme["drawer-selected-background-color"]};
         cursor: pointer;
      }
      &:active span {
         color: ${props => props.theme["active-color"]};
      }
   }
   & .drawer-subitem {
      & span {
         color: ${props => props.theme["banner-tab-link-color"]};
         font-weight: normal;
         font-size: 14px;
         text-indent: 25px;
      }
      &:hover span {
         color: ${props => props.theme["hover-color"]};
         cursor: pointer;
      }
      &:active span {
         color: ${props => props.theme["active-color"]};
      }
   }
   & .close-button {
      width: 100%;
      justify-content: flex-end;
      &:hover span {
         color: ${props => props.theme["hover-color"]};
         cursor: pointer;
      }
      &:active span {
         color: ${props => props.theme["active-color"]};
      }
   }
`);
exports.ZBanner = styles_1.withStyles(materialStyles)(styled_components_1.default(ZBannerComponent) `
   &#banner header {
      background: ${props => props.theme["banner-background-color"]};
   }
   & #hamburger-menu {
      position: absolute;
      top: 60px;
      left: 0px;
      height: 35px;
      width: 40px;
      & button {
         height: 35px;
         width: 40px;
         padding: 5px 10px 5px 10px;

         &:disabled,
         &:disabled ~ span {
            background: ${props => props.theme["disabled-color"]};
         }
      }
      background: ${props => props.theme["app-link-color"]};
      &.disabled {
         background: ${props => props.theme["disabled-color"]};
         cursor: default;
      }
   }
   & #toolbar,
   #offscreen-toolbar {
      grid-template-columns: auto auto;
      display: grid;
      width: 100%;
      background: ${props => props.theme["banner-background-color"]};
      color: ${props => props.theme["banner-tab-link-color"]};
      & span {
         color: ${props => props.theme["banner-tab-link-color"]};
      }
   }

   & #banner-items,
   #offscreen-banner-items {
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: 50px;
      white-space: nowrap;
      align-items: center;
      justify-items: left;
      width: max-content;
      & a {
         text-decoration: none;
         color: unset;
      }
      & button {
         background: transparent;
         &:hover {
            background: transparent;
         }
      }
   }
   & #username,
   #offscreen-username {
      font-size: 15px;
      white-space: nowrap;
      margin-left: 8px;
   }
   & #account-button,
   #offscreen-account-button {
      white-space: nowrap;
      align-self: center;
      justify-self: end;
      & button {
         padding-left: 10px;
      }
      & :hover * {
         color: ${props => props.theme["hover-color"]};
         cursor: pointer;
      }
      & :active * {
         color: ${props => props.theme["active-color"]};
      }
   }
`);
//# sourceMappingURL=ZBanner.js.map